import { ResolverTag } from '@ps/web-core-enums';
import { StarsLink } from '@ps/web-shared-ui';
import React from 'react';
import { Helmet } from 'react-helmet-async';

import TwitterIcon from '@swf/core/assets/icons/twitter-x.svg';
import useResolver from '@swf/core/hooks/useResolver';

import styles from '../SocialShareButtons.scss';

// Official documentation for Twitter Share Button - https://developer.twitter.com/en/docs/twitter-for-websites/tweet-button/overview

interface Props {
  iconStyle?: React.CSSProperties;
  url: string;
  onClick(e: React.MouseEvent): void;
}

const TwitterShareButton: React.FC<Props> = ({ url, onClick, iconStyle }) => {
  const twitterShare = useResolver(ResolverTag.TwitterShare, {
    query: { url: `${encodeURIComponent(url)}` }
  });

  return (
    <div>
      <Helmet>
        <script async defer src="https://platform.twitter.com/widgets.js" />
      </Helmet>
      <StarsLink
        data-track-id="RAF_Twitter"
        className={styles.shareButton}
        target="_blank"
        rel="noopener noreferrer"
        data-show-count="false"
        href={twitterShare}
        onClick={onClick}
      >
        <TwitterIcon style={iconStyle} />
      </StarsLink>
    </div>
  );
};
export default TwitterShareButton;
